export enum TrackerAction {
  Click = 'click',
  Interaction = 'interaction',
  Impression = 'impression',
}
